import { TimeUnit } from '~/basket/model/common/duration.model'

export default function getFormattedAmountAndDuration(
  amount: number,
  unit: TimeUnit,
  isOnlyPrice?: boolean,
): string {
  const formattedUnit = TimeUnit.MONTH === unit ? 'Meses' : 'Años'
  if (isOnlyPrice) return ''
  return amount === 0 ? 'Después' : `${amount} ${formattedUnit}`
}

export function formatBytes(a: number, b = 2) {
  if (a === 0) return '0 Bytes'
  const c = b < 0 ? 0 : b
  const d = Math.floor(Math.log(a) / Math.log(1024))
  return `${parseFloat((a / 1024 ** d).toFixed(c))} ${
    ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][d]
  }`
}

export function formatMinutes(sec: number): string {
  if (sec === 0) return 'Infinitos'
  if (!sec) return '0 Min'
  return `${Math.floor(sec / 60)} Min`
}
